import React from "react";
import {Snackbar} from "@material-ui/core";
import {Alert, AlertTitle} from "@material-ui/lab";
import {AuthContext} from "../../../auth/components/AuthProvider";
import firebase from "firebase";
import {useHistory} from "react-router-dom";

export const OrderFinalizationAlert = () => {

    const {userId} = React.useContext(AuthContext);
    const [orderIdsToFinalize, setOrderIdsToFinalize] = React.useState<string[] | null>(null);
    const history = useHistory();

    React.useEffect(() => {
        if (userId) {
            firebase.firestore()
                .collection("workerAlerts")
                .doc(userId)
                .get()
                .then((result) => setOrderIdsToFinalize(result.data() as string[]))
                .catch(() => {
                })
        }
    }, [userId]);

    const clearNotifications = () => {
        if (userId) {
            setOrderIdsToFinalize(null)
            firebase.firestore()
                .collection("workerAlerts")
                .doc(userId)
                .delete();
            history.push("/worker/schedule");
        }
    }

    return (
        <Snackbar
            open={Boolean(orderIdsToFinalize)}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            onClose={clearNotifications}
        >
            <Alert severity="warning" onClose={clearNotifications}>
                <AlertTitle>Aufträge finalisieren</AlertTitle>
                Bitte Trage für alle stattgefundenen Aufträge die Ist-Zeit ein.
            </Alert>
        </Snackbar>
    )
}
